import React from 'react'
import { isNil } from 'lodash'
import { IconPencil } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'

import { findVerifiedAnswerForAsk, stripSourceLabels } from './AiAnswers.helpers'
import { AiAnswersAnswerDrawer } from './AiAnswersAnswerDrawer'
import { AiAnswersEditAnswer } from './AiAnswersEditAnswer'

/**
 * @import import { AiAnswersSearchLogAction } from '@/views/AiAnswers/AiAnswersSearchLogAction'
 * @param {object} props
 * @param {object} props.row The search log ask
 * @param {object} [props.verifiedAnswers] The org's verified answers; null while loading or after
 *   a failed load, when no action is offered
 * @param {object} props.playbooks The org's playbook options and their load state
 * @param {number} props.organizationId The org the answer is written to
 * @param {Function} props.onChange Called after an answer is saved
 */
export const AiAnswersSearchLogAction = ({
  row,
  verifiedAnswers,
  playbooks,
  organizationId,
  onChange,
}) => {
  if (isNil(verifiedAnswers)) {
    return null
  }

  const verifiedAnswer = findVerifiedAnswerForAsk(row, verifiedAnswers.items)

  if (!isNil(verifiedAnswer)) {
    return (
      <AiAnswersEditAnswer
        verifiedAnswer={verifiedAnswer}
        verifiedAnswers={verifiedAnswers}
        playbooks={playbooks}
        organizationId={organizationId}
        onSaved={onChange}
      />
    )
  }

  // An unanswered ask is answered from Knowledge gaps; an older agent-gpt doesn't say which it is.
  if (row.no_answer !== false) {
    return null
  }

  return (
    <AiAnswersAnswerDrawer
      asks={[row]}
      initialAnswer={stripSourceLabels(row.answer)}
      verifiedAnswers={verifiedAnswers}
      playbooks={playbooks}
      organizationId={organizationId}
      onAnswered={onChange}
      trigger={(open) => (
        <Button basic small square aria-label="Edit answer" tooltip="Edit" onClick={open}>
          <IconPencil />
        </Button>
      )}
    />
  )
}
